import React from 'react';
import {Table, InputGroup, FormGroup, FormControl, Pager} from 'react-bootstrap';
import {inject, observer} from 'mobx-react'
import {injectIntl} from 'react-intl';

@injectIntl @inject('growStore') @observer
export default class UsersInfo extends React.Component{
    
    constructor(props){
        super(props);
    }

    render(){

        const {growStore, intl} = this.props;


        return (
        <div>


        <Table striped responsive style={{marginTop:25, textAlign: 'center'}}>
            <thead>
                <tr>
                    <th style={{textAlign: 'center'}}>{intl.formatMessage({id: "total_users_label"})}</th>
                </tr>
            </thead>

            <tbody>
                <tr>
                    <td>{growStore.totalUsers}</td>
                </tr>
            </tbody>


        </Table>

        <Table striped responsive>
            <thead>
                <tr>
                    <th style={{textAlign: 'center'}}>{intl.formatMessage({id: "user_name"})}</th>
                    <th style={{textAlign: 'center'}}>{intl.formatMessage({id: "user_email"})}</th>
                </tr>
            </thead>

            <tbody>

            {
                growStore.retrieveUsers.length > 0 ? growStore.retrieveUsers.map((p, idx) => {
                    return (<tr key={idx}>
                        <td style={{textAlign: 'center'}}>{p.name}</td>
                        <td style={{textAlign: 'center'}}>{p.email}</td>
                    </tr>);
                }) : <tr>
                        <td colSpan="5" style={{textAlign: 'center', fontSize: 30}}>
                            {intl.formatMessage({id: "no_results_message"})}
                            </td>
                    </tr>
            }

            </tbody>
        </Table>
        
        
        <Pager>
        <Pager.Item previous onClick={() => growStore.prevUsers()}
                    disabled={growStore.disablePrevUsers}>
            {intl.formatMessage({id: "pager_previous_label"})}
        </Pager.Item>
        <Pager.Item next onClick={() => growStore.nextUsers()}
                    disabled={growStore.disableNextUsers}>
            {intl.formatMessage({id: "pager_next_label"})}
        </Pager.Item>
        </Pager>
        </div>);
    }

}